export class  SortDto{
    constructor(
       public sorted?: boolean,
       public empty?: boolean,
       public unsorted?: boolean,
    ) {}
}